import { useMemo } from 'react';
import { HOME_APP_ROUTER_EXPERIMENT } from '~/constants/common/homeAppRouter';
import { useIsAppRouter } from '~/context/common/StaticContext';
import { useHomeRouterReason } from '~/context/home/GlobalContext';
import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';

// Skipped in both arms for SEBS treatment and composer_enabled sessions, which get App Router regardless of bucket.
export default function useTrackHomeAppRouterRendered(): void {
  const homeRouterReason = useHomeRouterReason();
  const isAppRouter = useIsAppRouter();

  const customAttributes = useMemo(
    () => ({ router: isAppRouter ? 'app' : 'pages' }),
    [isAppRouter]
  );

  useTrackRendered(
    HOME_APP_ROUTER_EXPERIMENT,
    homeRouterReason === 'appRouterExperiment',
    customAttributes
  );
}
